"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapHandlerToValues = exports.mapDynamicFiltersReverse = exports.mapDynamicFilters = void 0;
const date_fns_1 = require("date-fns");
function mapDynamicFilters(filterData, dynamicColumnData) {
    var _a, _b;
    const filter = [];
    if (dynamicColumnData) {
        const columnDefs = dynamicColumnData.columnDefs.filter((columnDef) => { var _a; return (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.showInFilters; });
        for (const columnDef of columnDefs) {
            const key = `_dynamic_${columnDef.name}`;
            // handle special case for date filter
            if (columnDef.type === 'number' && ((_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.columnHandlerName.toLowerCase().includes('date'))) {
                const valueBefore = filterData[key + '_before'];
                const valueAfter = filterData[key + '_after'];
                if (typeof valueBefore === 'string' && valueBefore) {
                    // TODO need support from Platform for this kind of filter
                    //filter.push({ column: key, op: '<=', value: `${valueBefore}T23:59:59.999[${serverTimeZoneFromSettings}]`});
                    const date = (0, date_fns_1.parseISO)(valueBefore + 'T23:59:59.999');
                    if ((0, date_fns_1.isValid)(date)) {
                        filter.push({ column: key, op: '<=', value: date.getTime() });
                    }
                    else {
                        console.warn('Invalid dynamic filter before date', valueBefore);
                    }
                }
                if (typeof valueAfter === 'string' && valueAfter) {
                    // TODO need support from Platform for this kind of filter
                    //filter.push({ column: key, op: '>=', value: `${valueAfter}T00:00:00.000[${serverTimeZoneFromSettings}]`});
                    const date = (0, date_fns_1.parseISO)(valueAfter + 'T00:00:00.000');
                    if ((0, date_fns_1.isValid)(date)) {
                        filter.push({ column: key, op: '>=', value: date.getTime() });
                    }
                    else {
                        console.warn('Invalid dynamic filter after date', valueAfter);
                    }
                }
            }
            else {
                const value = filterData[key];
                if (value != null) {
                    switch (columnDef.type) {
                        case 'boolean':
                            filter.push({ column: key, op: '=', value: value });
                            break;
                        case 'number':
                            if ((_b = columnDef.metadata) === null || _b === void 0 ? void 0 : _b.columnHandlerName.toLowerCase().includes('date')) {
                                // already handled
                            }
                            else if (Array.isArray(value)) {
                                filter.push({ column: key, op: 'overlap', value: value });
                            }
                            else {
                                filter.push({ column: key, op: '=', value: value });
                            }
                            break;
                        case 'number-array':
                            if (Array.isArray(value)) {
                                filter.push({ column: key, op: 'overlap', value: value });
                            }
                            else {
                                filter.push({ column: key, op: 'overlap', value: [value] });
                            }
                            break;
                        case 'string':
                            if (Array.isArray(value)) {
                                filter.push({ column: key, op: 'in', value: value });
                            }
                            else {
                                filter.push({ column: key, op: '=', value: value });
                            }
                            break;
                        case 'string-array':
                            if (Array.isArray(value)) {
                                filter.push({ column: key, op: 'overlap', value: value });
                            }
                            else {
                                filter.push({ column: key, op: 'overlap', value: [value] });
                            }
                            break;
                        case 'id':
                            filter.push({ column: key, op: 'in', value: value });
                            break;
                        case 'id-array':
                            filter.push({ column: key, op: 'overlap', value: value });
                            break;
                        case 'full-text-search':
                            filter.push({ column: key, op: 'full-text-query', value: value });
                            break;
                    }
                }
            }
        }
    }
    return filter;
}
exports.mapDynamicFilters = mapDynamicFilters;
function mapDynamicFiltersReverse(filters, dynamicColumnData) {
    var _a, _b, _c, _d;
    const result = {};
    if (dynamicColumnData) {
        const columnDefs = dynamicColumnData.columnDefs.filter((columnDef) => { var _a; return (_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.showInFilters; });
        for (const columnDef of columnDefs) {
            const key = `_dynamic_${columnDef.name}`;
            // handle special case for date filter
            if (columnDef.type === 'number' && ((_a = columnDef.metadata) === null || _a === void 0 ? void 0 : _a.columnHandlerName.toLowerCase().includes('date'))) {
                // TODO this will need to change after Platform implements and we start using filtering by date string
                const valueBefore = findFilterValue(filters, key, '<=', 'number');
                const valueAfter = findFilterValue(filters, key, '>=', 'number');
                result[key + '_before'] = valueBefore != null ? (0, date_fns_1.formatISO)(new Date(valueBefore)).substring(0, 10) : undefined;
                result[key + '_after'] = valueAfter != null ? (0, date_fns_1.formatISO)(new Date(valueAfter)).substring(0, 10) : undefined;
            }
            else {
                const values = mapHandlerToValues(dynamicColumnData.handlerMap.get((_c = (_b = columnDef.metadata) === null || _b === void 0 ? void 0 : _b.columnHandlerName) !== null && _c !== void 0 ? _c : ''));
                switch (columnDef.type) {
                    case 'boolean':
                        result[key] = findFilterValue(filters, key, '=', 'boolean');
                        break;
                    case 'number':
                        if ((_d = columnDef.metadata) === null || _d === void 0 ? void 0 : _d.columnHandlerName.toLowerCase().includes('date')) {
                            // already handled
                        }
                        else if (values) {
                            result[key] = findFilterValue(filters, key, 'overlap', 'array');
                        }
                        else {
                            result[key] = findFilterValue(filters, key, '=', 'number');
                        }
                        break;
                    case 'number-array':
                        if (values) {
                            result[key] = findFilterValue(filters, key, 'overlap', 'array');
                        }
                        else {
                            result[key] = findFilterValue(filters, key, 'overlap', 'array-of-one');
                        }
                        break;
                    case 'string':
                        if (values) {
                            result[key] = findFilterValue(filters, key, 'in', 'array');
                        }
                        else {
                            result[key] = findFilterValue(filters, key, '=', 'string');
                        }
                        break;
                    case 'string-array':
                        if (values) {
                            result[key] = findFilterValue(filters, key, 'overlap', 'array');
                        }
                        else {
                            result[key] = findFilterValue(filters, key, 'overlap', 'array-of-one');
                        }
                        break;
                    case 'id':
                        result[key] = findFilterValue(filters, key, 'in', 'array');
                        break;
                    case 'id-array':
                        result[key] = findFilterValue(filters, key, 'overlap', 'array');
                        break;
                    case 'full-text-search':
                        result[key] = findFilterValue(filters, key, 'full-text-query', 'string');
                        break;
                }
            }
        }
    }
    return Object.fromEntries(Object.entries(result).filter(([, value]) => value != null && (!Array.isArray(value) || value.length > 0)));
}
exports.mapDynamicFiltersReverse = mapDynamicFiltersReverse;
function findFilterValue(filters, column, op, typeofValue) {
    for (const f of filters) {
        if ('column' in f &&
            f.column === column &&
            f.op === op &&
            'value' in f &&
            (typeofValue === 'array' || typeofValue === 'array-of-one' ? Array.isArray(f.value) : typeof f.value === typeofValue) &&
            f.groupId == null) {
            if (typeofValue === 'array-of-one') {
                return f.value.length === 1 ? f.value[0] : undefined;
            }
            else {
                return f.value;
            }
        }
    }
    return undefined;
}
function mapHandlerToValues(columnHandler) {
    if (!(columnHandler === null || columnHandler === void 0 ? void 0 : columnHandler.data)) {
        return undefined;
    }
    const values = [];
    columnHandler.data.forEach((label, value) => {
        values.push({
            value,
            label,
        });
    });
    return values;
}
exports.mapHandlerToValues = mapHandlerToValues;
